/**
 * CURRENCIES STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getCurrencies,
    getCurrency,
    printCurrency,
    createCurrencies,
    updateCurrencies,
    deleteCurrencies,
} from "Core/configuration/currencies/config/api.currencies";

const state = {
    page: {},
    form: {},
    currencies: [],
    selectedCurrency: {
        currency_id: null,
        company_id: "",
        currency_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        currency_details: [],
    },
    currencies_filter: {
        search: "",
        is_active: "1",
        page_size: 20,
        page_num: 1,
    },
    rules_currencies: {
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        code: {
            name: "code",
            rules: "trim|max_length[10]|required",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        name: {
            name: "name",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        prefix: {
            name: "prefix",
            rules: "trim|max_length[10]",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        suffix: {
            name: "suffix",
            rules: "trim|max_length[10]",
            max_len: "10",
            min_len: "",
            default_value: "",
        },
        precision: {
            name: "precision",
            rules: "trim|max_length[2]|integer",
            max_len: "2",
            min_len: "",
            default_value: "2",
        },
        decimal: {
            name: "decimal",
            rules: "trim|max_length[1]",
            max_len: "1",
            min_len: "",
            default_value: ".",
        },
        thousands: {
            name: "thousands",
            rules: "trim|max_length[1]",
            max_len: "1",
            min_len: "",
            default_value: ",",
        },
        mask: {
            name: "mask",
            rules: "trim|max_length[24]",
            max_len: "24",
            min_len: "",
            default_value: "",
        },
        is_active: {
            name: "is_active",
            rules: "trim|max_length[1]|integer",
            max_len: "1",
            min_len: "",
            default_value: "1",
        },
    },
};

// getters
const getters = {
    currencies: (state) => {
        return state.currencies;
    },
};

// actions
const actions = {
    async fetchCurrencies({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getCurrencies({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageCurrencies", response.data.page);
                }

                commit("setCurrencies", response.data.currencies);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchCurrency({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getCurrency(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedCurrency", response.data.currency);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printCurrency({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printCurrency(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveCurrency({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["currency_id"] === "undefined" || body["currency_id"] == null || body["currency_id"] == "") {
                delete body["currency_id"];
                response = await createCurrencies({ body: body, headers: config.headers });
            } else {
                let currency_id = body["currency_id"];
                delete body["currency_id"];
                response = await updateCurrencies({ body: body, headers: config.headers }, currency_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteCurrency({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteCurrencies(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageCurrencies(state, page) {
        state.page = page;
    },
    setCurrencies(state, currencies) {
        state.currencies = currencies;
    },
    setSelectedCurrency(state, currency) {
        state.selectedCurrency = currency;
    },
    resetSelectedCurrency(state) {
        for (const key in state.selectedCurrency) {
            if (key in state.rules_currencies) {
                state.selectedCurrency[key] = state.rules_currencies[key].default_value == "null" ? null : state.rules_currencies[key].default_value;
            }
        }
    },
    resetCurrencies(state) {
        state.page = {};
        state.form = {};
        state.currencies = [];
        state.selectedCurrency = {
            currency_id: null,
            company_id: "",
            currency_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            currency_details: [],
        };
        state.currencies_filter = {
            search: "",
            is_active: "1",
            page_size: 20,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
